import React from 'react';

import currencyHelper from '../../../../helpers/currencyHelper';
import { I18n } from 'react-redux-i18n';

export const DonationGiftMatchingItem = ({ entry }) => {
  const { amount, currency, entity, mainImageUrl } = entry;

  const matcherName = entity || I18n.t("donation.donation-view.donation-details.gift-matching-anonymous");
  return (
    <div className="view-details-content-row page">
      {mainImageUrl && 
        <img 
          alt={entity || ''} 
          src={mainImageUrl} 
          className="gift-matching-entity-thumbnail"
        />}
      <div className="page-content">
        <h4>{matcherName} {I18n.t("donation.donation-view.donation-details.gift-matching-entity-detail")}</h4>
        <span>{currencyHelper.formatCurrency(amount, currency)}</span>
      </div>
    </div>
  );
};
